import * as React from "react";
import clsx from "clsx";
import sx from "./basic-hero.module.css";

export type HeroProps = {
	backgroundImageUrl: string;
	heading: any;
	srcSet?: string;
	sizes?: string;
};

function BasicHero({
	heading,
	backgroundImageUrl,
	srcSet,
	sizes,
}: HeroProps): JSX.Element {
	return (
		<div className={clsx(sx.root, "min-h-hero lg:min-h-heroLarge")}>
			<div className={clsx(sx.imageOverlay, "absolute w-full h-full")}>
				<div className={clsx(sx.imageClip, "w-full h-full")}>
					<img
						{...(srcSet && { srcSet })}
						{...(sizes && { sizes })}
						src={backgroundImageUrl}
						className={clsx(sx.imageClip, "w-full h-full object-cover")}
						width={2000}
						height={1333}
						alt=""
					/>
				</div>
			</div>
			{heading && (
				<div className="absolute flex flex-col justify-end w-full h-full -bottom-6 max-w-7xl">
					<h1 className={clsx(sx.heading)}>{heading}</h1>
				</div>
			)}
		</div>
	);
}

export default BasicHero;
